import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DATE_FORMATS } from '@app/core/models/date-adapter';

@Component({
    selector: 'tt-comment',
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.css'],
})
export class CommentComponent implements OnChanges {
    @Input()
    public ttAuthor: string = '';

    @Input()
    public ttDatetime: string = '';

    @Input()
    public ttComment: string = '';

    public comment?: SafeHtml;

    @Input()
    public set ttIsCurrentUser(value: BooleanInput | '1' | '0') {
        if (value === '1') this._isCurrentUser = true;
        else if (value === '0') this._isCurrentUser = false;
        else this._isCurrentUser = coerceBooleanProperty(value);
    }
    public get ttIsCurrentUser(): boolean | '1' | '0' {
        return this._isCurrentUser;
    }
    private _isCurrentUser = false;

    public format: string;

    constructor(private sanitizer: DomSanitizer) {
        this.format = DATE_FORMATS.display.dateInput.format;
    }

    @HostListener('click', ['$event'])
    public onCommentClick(event: MouseEvent) {
        if (!!event.target && (event.target as HTMLElement).tagName === 'IMG') {
            let src = (event.target as HTMLImageElement).src;

            if (!src) return;

            if (src.endsWith('?w=800&scale.option=noup')) {
                src = src.replace('?w=800&scale.option=noup', '');
            }

            window.open(src, '_blank');
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttComment']) {
            this.comment = this.sanitizer.bypassSecurityTrustHtml(changes['ttComment'].currentValue);
        }
    }
}
// (function () {
//   const module = angular.module('imApp');

//   /**
//    * @author JLR
//    * @version 20231215
//    */

//   /**
//    * @typedef {Object} CommentProps represents the properties of the ttComment component.
//    * @property {string} ttAuthor the displayed name of the author of the comment.
//    * @property {string?} ttDatetime the date and time of the comment was created.
//    * @property {string} ttModel the content of the comment.
//    * @property {'1' | '0'} ttIsCurrentUser whether the author of the comment is the current user.
//    */

//   module.component('ttComment', {
//       // All actions to display next to the comment is places in transclude.
//       transclude: true,
//       templateUrl: 'views/components/directives/ttComment/ttComment.template.html?v=' + module.version,
//       controllerAs: 'vm',
//       /** @type CommentProps */
//       bindings: {
//           ttAuthor: '@',
//           ttDatetime: '@?',
//           ttModel: '<',
//           ttIsCurrentUser: '<',
//           ttMenuOptions: '<',
//       },
//       controller: [function () {
//           const vm = this;

//           vm.id = {
//               content: crypto.randomUUID(),
//           }

//           let setInnerHtml = function (htmlString) {
//               setTimeout(() => {
//                   let element = document?.getElementById(vm.id.content);

//                   if (element) {
//                       element.innerHTML = htmlString;
//                   }
//               })
//           }

//           vm.$onChanges = function (changes) {
//               if (changes?.ttModel?.currentValue && typeof changes.ttModel.currentValue === 'string') {
//                   setInnerHtml(changes?.ttModel.currentValue);
//               }
//           }

//       }]
//   });
// })();
